export default __webpack_public_path__ + "static/media/twiter-bold.3acf4e87.svg";